<template>
  <div class="w5">
    <el-tabs v-model="tabsIndex1">
      <el-tab-pane v-for="(item, index) in appdataList" :label="item.name" :key="index">
        <ul class="ul2" v-if="item.data && item.data.length > 0">
          <li v-for="(items, child) in item.data" :key="child">
            <div class="imgbox" v-if="items.activityInfo.image">
              <img class="imgtop" :src="items.activityInfo.image" alt="">
            </div>
            <div class="txtbox">
              <h2 class="textover">{{ items.activityInfo.name }}</h2>
              <p class="textover color888"><i class="el-icon-date"></i> {{ getTime(items.activityInfo.beginTime) }} - {{ getTime(items.activityInfo.endTime) }}</p>
              <p class="textover color888" v-if="items.activityInfo.address !== undefined && items.activityInfo.address !== ''"><i class="el-icon-location-outline"></i> {{ items.activityInfo.address }}</p>
              <p class="textover color888" v-if="items.sessionName !== undefined && items.sessionName !== ''"><i class="el-icon-wind-power"></i> {{ items.sessionName }}</p>
              <!-- 状态 0未使用 1已使用 2已退订 3已失效-->
              <el-button round class="btn" type="warning" v-if="items.status.code === 0">{{ items.status.description }}</el-button>
              <el-button round class="btn" type="danger" v-if="items.status.code !== 0">{{ items.status.description }}</el-button>
              <el-button round class="btn" type="warning" v-if="items.status.code === 0" plain @click="appunsubscribe(items.id)">退订</el-button>
            </div>
          </li>
        </ul>
        <nodata v-if="item.data && item.data.length === 0" nodataflag="true"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getuserappointment, setappointmentunsubscribe } from '@/api/user/index'
import { timeFormat } from '@/utils/validate'
import nodata from '@/components/nodata/index'
export default {
  name: 'userappointment',
  components: {
    nodata
  },
  data () {
    return {
      tabsIndex1: 0,
      appdataList: []
    }
  },
  mounted () {
    this.userappointment()
  },
  methods: {
    getTime (val) {
      let hhmm = timeFormat(val, 'yymmddhhmm').split(' ')[1]
      if (hhmm === '00:00') {
        return timeFormat(val, 'yymmdd')
      } else {
        return timeFormat(val, 'yymmddhhmm')
      }
    },
    /* 活动报名data */
    userappointment () {
      getuserappointment(this.$cookie.get('wlyuserid')).then((res) => {
        this.appdataList = []
        let all = {name: '全部', data: []}
        for (let i in res.data) {
          if (i === 'unused') this.appdataList.push({ name: '未使用', data: res.data[i] })
          if (i === 'unsubscribed') this.appdataList.push({ name: '已退订', data: res.data[i] })
          if (i === 'expired') this.appdataList.push({ name: '已失效', data: res.data[i] })
          if (i === 'used') this.appdataList.push({ name: '已使用', data: res.data[i] })
          all.data = all.data.concat(res.data[i])
        }
        this.appdataList.splice(0, 0, all)
      })
    },
    /* 活动报名退订 */
    appunsubscribe (id) {
      this.$confirm('是否退订', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setappointmentunsubscribe(id).then((res) => {
          if (res.data.rel) {
            this.$message({message: res.data.data, type: 'success', duration: 1500})
            this.userappointment()
          } else {
            this.$message.error(res.data.data)
          }
        })
      }).catch(() => { })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/common/scss/user.scss";
</style>



// WEBPACK FOOTER //
// src/view/personalcenter/userappointment.vue